import React, { useState, useEffect } from 'react'
import './css/completionInd.css'

const CompletionInd = (props) => {
    const [style, setStyle] = useState({})
    const [completionPct, setCompletionPct] = useState(props.completionPct)
    useEffect(() => {
        setCompletionPct(props.completionPct)

    }, [props])
    setTimeout(() => {
        const newStyle = {
            opacity: 1,
            width: `${completionPct.pct}%`
        }
        setStyle(newStyle);
    }, 200);

    return (
        <div>
            <div className="col-sm-12 padding-remove" >
                <h1 style={{ fontSize: 20 }}>Completion</h1>
            </div>
            <div className="col-sm-12 padding-remove" >
                <div className="col-sm-6 padding-remove"  >
                    <div className="progress" style={{ display: 'inline-table' }}>
                        <div className="progress-done" style={style}>
                        </div>
                    </div>
                    <div  style={{ display: 'inline-table', marginLeft: '15px' }}>
                        { completionPct.total ?
                        <span style={{ fontSize: 20 }}>{completionPct.completed + '/' + completionPct.total}</span>
                        : null
                        }
                    </div>
                </div>
                <div className="col-sm-6 padding-remove " >
                    <div className="col-sm-5 padding-remove text-right" >
                        <button className="button-disruption"   style={{ width: "90%" }}  onClick={props.autoSubstitution}> Auto Substitution</button>
                    </div>
                    <div className="col-sm-4"></div>
                    <div className="col-sm-1 padding-remove text-right" >
                        <img src={require("common/images/pdf.png")} style={{cursor: 'pointer', height:30}} onClick={(e) => props.setFlgView(true)} alt="Subs. Duty PDF" title="Subs. Duty PDF"/>

                        {/* <button className="button-disruption"  style={{ width: "90%" }}  onClick={(e) => props.setFlgView(true)}>View</button> */}
                    </div>
                    <div className="col-sm-1 padding-remove text-right" >
                    	 <img src={require("common/images/excel.png")} style={{cursor: 'pointer', height:30}} onClick={(e) => props.downloadExcel()} alt="Subs. Duty Excel" title="Subs. Duty Excel"/>
                    </div>
                    <div className="col-sm-1 padding-remove text-right" >
                        <span className="glyphicon glyphicon-remove-circle"  style={{fontSize:27, cursor:'pointer', color:'gray' }}  onClick={props.handleRemoveSubstituion} title="Remove all substitutions"></span>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default CompletionInd;